/**
 * Schema definition for Property Right Form
 */

import { BuiltInFormSchema } from '../types/builtInFormSchema';

export const propertyRightFormSchema: BuiltInFormSchema = {
  formId: 'property_right',
  formTitle: 'Property Right',
  
  sections: [
    // Section 1: Right Side Elevation
    {
      id: 'right_elevation',
      title: 'Right Side Elevation',
      fields: [
        {
          id: 'rightElevationImage',
          type: 'photo',
          label: 'Right Elevation',
          required: true,
          maxPhotos: 999
        },
        {
          id: 'roofTypeEvidenceImages',
          type: 'photo',
          label: 'Roof Type Evidence',
          required: true,
          maxPhotos: 999,
          helpText: 'Right elevation roof images'
        },
        {
          id: 'rightSideImages',
          type: 'photo',
          label: 'Additional Right Side Images',
          maxPhotos: 999
        }
      ]
    },
    
    // Section 2: Guttering & Drainage
    {
      id: 'guttering_right',
      title: 'Guttering & Drainage',
      fields: [
        {
          id: 'gutteringDrainageImages',
          type: 'photo',
          label: 'Guttering & Drainage Photos (Right)',
          maxPhotos: 999
        }
      ]
    },
    
    // Section 3: External Wall Details (Right)
    {
      id: 'wall_right',
      title: 'External Wall Details (Right)',
      fields: [
        {
          id: 'externalWallType',
          type: 'dropdown',
          label: 'External Wall Type',
          required: true,
          options: [
            { value: '', label: 'Select Wall Type' },
            { value: 'brick', label: 'Brick' },
            { value: 'stone', label: 'Stone' },
            { value: 'concrete', label: 'Concrete' },
            { value: 'timber', label: 'Timber Frame' },
            { value: 'render', label: 'Render' },
            { value: 'other', label: 'Other' }
          ]
        },
        {
          id: 'externalWallCondition',
          type: 'dropdown',
          label: 'External Wall Condition',
          required: true,
          options: [
            { value: '', label: 'Select Condition' },
            { value: 'excellent', label: 'Excellent' },
            { value: 'good', label: 'Good' },
            { value: 'fair', label: 'Fair' },
            { value: 'poor', label: 'Poor' },
            { value: 'very_poor', label: 'Very Poor' }
          ]
        },
        {
          id: 'wallTypeEvidenceImage',
          type: 'photo',
          label: 'Wall Type Evidence',
          required: true,
          maxPhotos: 999
        },
        {
          id: 'isWallInsulated',
          type: 'boolean',
          label: 'Is the Wall Insulated?',
          required: true,
          style: 'yes-no-na'
        },
        {
          id: 'hasWallDefects',
          type: 'boolean',
          label: 'Additional visible wall defects?',
          style: 'yes-no'
        },
        {
          id: 'wallDefectImages',
          type: 'photo',
          label: 'Images of Wall Defects (Right)',
          required: true,
          maxPhotos: 999,
          conditionalOn: {
            fieldId: 'hasWallDefects',
            value: true
          }
        }
      ]
    },
    
    // Section 4: Additional Notes
    {
      id: 'notes_right',
      title: 'Additional Notes',
      fields: [
        {
          id: 'additionalNotes',
          type: 'textarea',
          label: 'Additional Notes for Property Right',
          rows: 3,
          placeholder: 'Enter any other relevant details for the right side of the property...'
        }
      ]
    }
  ],
  
  defaultSectionOrder: [
    'right_elevation',
    'guttering_right',
    'wall_right',
    'notes_right'
  ]
};
